import { cn } from "@/utils/cssHelpers";
import React from "react";

export type CaDotDecorationProps = {
  className?: string;
};

function CaDotDecoration({ className }: CaDotDecorationProps) {
  return (
    <svg
      width='65'
      height='61'
      viewBox='0 0 65 61'
      fill='none'
      className={cn(className)}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='0.832031' cy='0.832031' r='0.832031' fill='currentColor' />
      <circle cx='16.4961' cy='0.832031' r='0.832031' fill='currentColor' />
      <circle cx='32.1602' cy='0.832031' r='0.832031' fill='currentColor' />
      <circle cx='47.8242' cy='0.832031' r='0.832031' fill='currentColor' />
      <circle cx='63.4883' cy='0.832031' r='0.832031' fill='currentColor' />
      <circle cx='0.832031' cy='15.4961' r='0.832031' fill='currentColor' />
      <circle cx='16.4961' cy='15.4961' r='0.832031' fill='currentColor' />
      <circle cx='32.1602' cy='15.4961' r='0.832031' fill='currentColor' />
      <circle cx='47.8242' cy='15.4961' r='0.832031' fill='currentColor' />
      <circle cx='63.4883' cy='15.4961' r='0.832031' fill='currentColor' />
      <circle cx='0.832031' cy='30.1602' r='0.832031' fill='currentColor' />
      <circle cx='16.4961' cy='30.1602' r='0.832031' fill='currentColor' />
      <circle cx='32.1602' cy='30.1602' r='0.832031' fill='currentColor' />
      <circle cx='47.8242' cy='30.1602' r='0.832031' fill='currentColor' />
      <circle cx='63.4883' cy='30.1602' r='0.832031' fill='currentColor' />
      <circle cx='0.832031' cy='44.8242' r='0.832031' fill='currentColor' />
      <circle cx='16.4961' cy='44.8242' r='0.832031' fill='currentColor' />
      <circle cx='32.1602' cy='44.8242' r='0.832031' fill='currentColor' />
      <circle cx='47.8242' cy='44.8242' r='0.832031' fill='currentColor' />
      <circle cx='63.4883' cy='44.8242' r='0.832031' fill='currentColor' />
      <circle cx='0.832031' cy='59.4883' r='0.832031' fill='currentColor' />
      <circle cx='16.4961' cy='59.4883' r='0.832031' fill='currentColor' />
      <circle cx='32.1602' cy='59.4883' r='0.832031' fill='currentColor' />
      <circle cx='47.8242' cy='59.4883' r='0.832031' fill='currentColor' />
      <circle cx='63.4883' cy='59.4883' r='0.832031' fill='currentColor' />
    </svg>
  );
}

CaDotDecoration.defaultProps = {
  className: "",
};

export default CaDotDecoration;
